import React, { Component } from 'react';
import PropTypes from 'prop-types';
import  '../../../containers/AdminConfig/css/AdminConfig.css';
import '../../../containers/AdminConfig/js/AdminConfig';
import {AlertConfirm, AlertCommit} from '../../../Modals/AlertBar';
import { checkStatus,getMonthTHFromInt } from '../../../../util/util';
import DriverList from './DriverList';
import NewDriver from './NewDriver';
import UpdateDriver from './UpdateDriver';
import ImportExportDriver from './ImportExportDriver';
import { withNamespaces } from 'react-i18next';

class Drivers extends Component {

    constructor() {
        super();

        this.state = {
            dataNewDriver:{},
            openList : true,
            openAdd : false,
            openEdit: false,
            dataUpdate: {}
        };

    }

    onValidateComplete = (data) => {
        this.setState({dataNewDriver: data}, () => this.onCilckAddDriver());
    }

    onCilckAddDriver = () => {
        this.setState({ });

        AlertConfirm("เพิ่มพนักงานขับรถ","คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk=>{
            if(isOk){
                const { dataNewDriver } = this.state;
                const {
                    user_name,
                    user_id,
                    token
                } = this.props;

                    fetch(`http://203.150.199.244/api/admin/newDriver`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({
                        "prefix":dataNewDriver.prefix,
                        "first_name":dataNewDriver.first_name,
                        "last_name":dataNewDriver.last_name,
                        "gender":dataNewDriver.gender,
                        "telephone":dataNewDriver.telephone,
                        "birthday": dataNewDriver.birthday,
                        "card_number":dataNewDriver.card_number,
                        "card_registrar":dataNewDriver.card_registrar,
                        "card_nation":dataNewDriver.card_nation,
                        "license_type":dataNewDriver.license_type,
                        "license_gov":dataNewDriver.license_gov,
                        "license_number":dataNewDriver.license_number,
                        "license_start":dataNewDriver.license_start,
                        "license_expire":dataNewDriver.license_expire,
                        "note":dataNewDriver.note,
                    })
                })
                    .then(response => { return checkStatus(response)})
                    .then((data) => {

                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                        this.setState({
                            openList : true,
                            openAdd : false,
                            openEdit : false,
                        });

                    })
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
                }
            });
    }

    onValidateEditDriver = (data) => {
        this.setState({dataUpdate: data}, () => this.onClickEditDriver());
    }

    onClickEditDriver = () => {
        const { t } = this.props;
        this.setState({ });

        AlertConfirm("แก้ไขพนักงานขับรถ","คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk=>{
            if(isOk){
                const { dataUpdate } = this.state;
                const {
                    user_name,
                    user_id,
                    token
                } = this.props;

                    fetch(`http://203.150.199.244/api/admin/updateDriver/${dataUpdate.driver_id}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({
                        "prefix":dataUpdate.prefix,
                        "first_name":dataUpdate.first_name,
                        "last_name":dataUpdate.last_name,
                        "gender":dataUpdate.gender,
                        "telephone":dataUpdate.telephone,
                        "birthday": dataUpdate.birthday,
                        "card_number":dataUpdate.card_number,
                        "card_registrar":dataUpdate.card_registrar,
                        "card_nation":dataUpdate.card_nation,
                        "license_type":dataUpdate.license_type,
                        "license_gov":dataUpdate.license_gov,
                        "license_number":dataUpdate.license_number,
                        "license_start":dataUpdate.license_start,
                        "license_expire":dataUpdate.license_expire,
                        "note":dataUpdate.note,
                    })
                })
                    .then(response => { return checkStatus(response)})
                    .then((data) => {
                        if(data.RESULT_STATUS === "000")
                            AlertCommit(true, t('บันทึกข้อมูลเรียบร้อยแล้ว'));
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                        this.setState({
                            openList : true,
                            openAdd : false,
                            openEdit : false,
                        });

                    })
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
                }
            });
    }

    onClickBack = () =>{
        this.setState({
            openList : true,
            openAdd : false,
            openEdit : false,
        });
    }

    onOpenAdd = () => {
        // this.setState({dataNewDriver: data}, () => this.onClickConfirmUserInformation());
        this.setState({
            openList : false,
            openAdd : true,
        });
    }

    onOpenEdit = (driver) => {
        this.setState({
            openList : false,
            openEdit : true,
            dataUpdate:driver,
        });
    }

    onDelete = (driverId) => {

        AlertConfirm("ลบพนักงานขับรถ","คุณต้องการลบพนักงานขับรถหรือไม่").then(isOk=>{
            if(isOk){
                const {
                    user_name,
                    user_id,
                    sideBarName,
                    token,
                } = this.props;

                const { deviceSelectID } = this.state;

                fetch(`http://203.150.199.244/api/admin/deleteDriver/${driverId}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token":token,
                    },
                    body: JSON.stringify({
                        // "device_status":"Inactive"
                    })
                })
                    .then(response => { return checkStatus(response)})
                    .then((data) => {

                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"ลบข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                        this.setState({
                            openList : true,
                            openAdd : false,
                            openEdit : false,
                        });

                    })
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
                }
            });
    }

    render() {
        const { t, user_id, user_name,token, sideBarName ,userLevel} = this.props;
        const {
            openAdd,
            openList,
            openEdit,
            dataUpdate
        } = this.state;
        return (
                <div className="gray-panel">
                    <div className="col-12">
                        <h1 className="page-header"> <i className="fa fa-id-card" style={{color: '#7386D5'}} />{t('พนักงานขับรถ')}</h1>
                    </div>
                    <div>
                        { openAdd &&
                            <NewDriver
                                user_id={user_id}
                                user_name={user_name}
                                token={token}
                                userLevel={userLevel}
                                sideBarName={sideBarName}
                                onSubmit={this.onValidateComplete}
                                onBack={this.onClickBack}
                            />
                        }
                        { openEdit &&
                            <UpdateDriver
                                user_id={user_id}
                                user_name={user_name}
                                token={token}
                                userLevel={userLevel}
                                sideBarName={sideBarName}
                                onSubmitEdit={this.onValidateEditDriver}
                                onBack={this.onClickBack}
                                dataUpdate={dataUpdate}
                            />
                        }
                        {openList &&
                        <div>
                        <nav>
                        <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                             <a className="nav-item nav-link active" id="nav-list-tab" data-toggle="tab" href="#nav-list" role="tab" aria-controls="nav-list" aria-selected="true">{t('รายการ')}</a>
                            {/* <a className="nav-item nav-link" id="nav-new-tab" data-toggle="tab" href="#nav-new" role="tab" aria-controls="nav-new" aria-selected="false">เพิ่มข้อมูลใหม่</a> */}
                            <a className="nav-item nav-link" id="nav-import-tab" data-toggle="tab" href="#nav-import" role="tab" aria-controls="nav-import" aria-selected="false">{t('นำเข้า/ส่งออก')}</a>
                        </div>
                    </nav>
                    <div className="tab-content py-3 px-3 px-sm-0" id="nav-tabContent">
                        <div className="tab-pane fade show active" id="nav-list" role="tabpanel" aria-labelledby="nav-list-tab">
                            <DriverList
                                t={t}
                                user_id={user_id}
                                user_name={user_name}
                                token={token}
                                userLevel={userLevel}
                                sideBarName={sideBarName}
                                openAdd={this.onOpenAdd}
                                openEdit={this.onOpenEdit}
                                onDelete={this.onDelete}
                            />
                        </div>
                        <div className="tab-pane fade" id="nav-import" role="tabpanel" aria-labelledby="nav-import-tab">
                            <ImportExportDriver
                                t={t}
                                user_id={user_id}
                                user_name={user_name}
                                token={token}
                            />
                        </div>
                    </div>
                    </div>
                        }

                    </div>
                </div>

            );
        }
    }

export default withNamespaces('Menubar')(Drivers);



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/Drivers.js